import { Physician } from "services/types/physician.type";

import { getFullName } from "./common";

export const formatPhysician = (physician: Physician): Physician => ({
  ...physician,
  fullAddress: getFullAddress(physician),
  full_name:
    physician.full_name ||
    getFullName({
      firstName: physician.first_name || "",
      middleName: physician.middle_name || "",
      lastName: physician.last_name || "",
      title: physician.title,
      suffix: physician.suffix
    })
});

const getFullAddress = (physician: Physician) => {
  const address = [
    physician.street_address_1,
    physician.city,
    `${physician.state || ""} ${physician.zip_code || ""}`.trim()
  ].filter(Boolean);

  return address.join(", ");
};

export const getPhysicianAsText = (
  value: (Physician & { is_primary_care?: boolean }) | null | undefined
) => {
  return getFullName({
    firstName: value?.first_name ?? "",
    lastName: value?.last_name ?? "",
    title: value?.title,
    suffix: value?.suffix
  });
};

export const getPhysiciansAsText = (
  physicians?: Array<Physician | undefined>
) => {
  return (physicians?.filter((option) => option) ?? [])
    .map((value) => getPhysicianAsText(value))
    .join(", ");
};
